// custom-cart-page-js.js
// called on the cart page only



jQuery(document).ready(function($){


    // handle opening of special instructions box on mobile cart page
    $('#mobileSpecialInstructionsTop').on('click', function(e){
      if($('#mobileSpecialInstructionsBottom').css('display') === 'none'){
       $('#mobileSpecialInstructionsBottom').css('display', 'flex');
       $('#specialInstructionIcon').removeClass('fa-plus-circle');
       $('#specialInstructionIcon').addClass('fa-minus-circle');
      } else {
       $('#mobileSpecialInstructionsBottom').css('display', 'none');
	   $('#specialInstructionIcon').addClass('fa-plus-circle');
       $('#specialInstructionIcon').removeClass('fa-minus-circle');
      }
    });


  setTimeout(function(){
    // handle items in cart page
          $("div[id*='product-cart-item-']").each(function(i, el){
            $(el).ready(function(e){
              var cartItemObject = $(el).clone();
              var id = cartItemObject.find('#cartItemId').val();
              var casePackQuantity = parseInt(cartItemObject.find('#cartItemCasePackQuantity').val());             
              var totalPrice = cartItemObject.find('.money').text().replace('$', '');
              var realTotalPrice = totalPrice.replace(',','');
              var totalPriceFloat = parseFloat(realTotalPrice);
              var quantity = parseInt(cartItemObject.find('.js--num').val());  
              var unitPrice = parseFloat(totalPriceFloat / quantity).toFixed(2);  
              
              
              var cartItemQuantityContainer = '#product-cart-item-' + id + ' > .cart-item-quantity-container > .js-qty';
              var cartItemQuantityId = '#product-cart-item-' + id + ' > .cart-item-quantity-container > .js-qty > input';
              var cartItemQuantityMinus = '#product-cart-item-' + id + ' > .cart-item-quantity-container > .js-qty > .js--minus';
              var cartItemQuantityAdd = '#product-cart-item-' + id + ' > .cart-item-quantity-container > .js-qty > .js--add';
              var cartItemUnits = '#product-cart-item-' + id + ' > .cart-item-quantity-container > .cart-items-unit-count';
              
              
              // for product item on cart page
              // update quantity when user is done changing quanity / when the users mouse leaves the update quantity box
              $(cartItemQuantityContainer).on('mouseleave', function (e){
                var changedInput = parseInt($(cartItemQuantityId).val());
                if (changedInput != quantity){
                	$('.update-cart').trigger("click");
                }	
              });
              
              
              // do not allow quantity to be less than 1 for product item on cart page
              $(cartItemQuantityMinus).on('click', function(){
                if( $(cartItemQuantityId).val() < 1 ){$(cartItemQuantityId).val(1);}
                var pieceCount = $(cartItemQuantityId).val() * casePackQuantity;
                if(pieceCount > 1){
                  $(cartItemUnits).text(`${pieceCount} units`)
                } else {
                  $(cartItemUnits).text(`${pieceCount} unit`)
                }
              });
              
              // increment quantity for product item on cart page
              $(cartItemQuantityAdd).on('click', function(){
                if( $(cartItemQuantityId).val() < 1 ){$(cartItemQuantityId).val(1);}
                var pieceCount = $(cartItemQuantityId).val() * casePackQuantity;
                if(pieceCount > 1){
                  $(cartItemUnits).text(`${pieceCount} units`)
                } else {
                  $(cartItemUnits).text(`${pieceCount} unit`)
                }
              });
              
              // focus input on product item 
              $(cartItemQuantityId).on('focus', function(e){$(this).select();});

              // do not allow quantity to be less than 1 for product item on cart page when entering input amount
              $(cartItemQuantityId).on('input', function(e) {
                var quantityValue = $(this);
                if(quantityValue.val() < 1){quantityValue.val(1);}
              });

              // calculate total units
              var totalUnits = (casePackQuantity * quantity);

              // set total units count
              if (totalUnits == 1){
                var totalUnitsText = ''+ totalUnits + ' unit';
        	  	  ß$('#cartItemUnitsCount'+id).text(totalUnitsText);
              } else  {
                var totalUnitsText = ''+ totalUnits + ' units';
        	  	  $('#cartItemUnitsCount'+id).text(totalUnitsText);
              }
              var totalUnitsText = ''+ totalUnits + ' units';
              $('#cartItemUnitPrice'+id).text(unitPrice);
            });
          });
  }, 1100);
	
  
});